import React from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import ModalTerm from '../pages/responsiveReservation/termCond'
import { isPermissionExist, allowAlphaNumericOnly, requiredTextInput } from '../utils/helper'

const TCAcceptanceSection = ({
    accessPermissions,
    formData,
    setFormData,
    formError,
    partnerDetails,
    validator,
    showTerm,
    setShowTerm,
    handleInputFieldsData,
    tncDisabled
}) => {

    const handleAcknowledge = (e) => {
        const { name, checked } = e.target
        setFormData({ ...formData, [name]: checked })
    }

    const handleModalTerm = () => {
        setShowTerm(!showTerm)
    }

    if (!isPermissionExist(accessPermissions, 'Display Terms & Conditions')) return null

    return (
        <>
            {isPermissionExist(accessPermissions, 'Display Terms & Conditions') ? <div className="form-check ms-2">
                <input disabled={tncDisabled} className="form-check-input" type="checkbox" id="userAcknowledge" name="userAcknowledge" required onClick={(e) => handleAcknowledge(e)} checked={formData?.userAcknowledge} />
                <small>I have read and agreed to the {partnerDetails?.term_condition_heading ? partnerDetails?.term_condition_heading : 'ParkEngage'}  <a href='javascript:;' onClick={handleModalTerm}>Terms & Conditions</a>.</small>
                <span className="form-text text-danger h-40 d-block">{formError && !formData?.userAcknowledge ? 'Please provide your acknowledgement on above Terms and Conditions.' : ''}</span>
                <ModalTerm partnerDetails={partnerDetails} facilityId={formData?.facility_id} setShow={setShowTerm} show={showTerm} />

            </div> : null}
            {isPermissionExist(accessPermissions, 'Display Terms & Conditions') && isPermissionExist(accessPermissions, 'Display TC Acceptance') ? <div className="form-check ms-2">
                {formData?.userAcknowledge ?
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="mb-2">
                                <label className="form-label">T&C Acceptance Signature <span className='text-danger'> *</span></label>
                                <input
                                    //    ref={inputRef}
                                    disabled={tncDisabled}
                                    className="form-control "
                                    id="tc_acceptance_signature"
                                    name="tc_acceptance_signature"
                                    placeholder="Full Name"
                                    maxLength={20}
                                    minLength={1}
                                    value={formData?.tc_acceptance_signature ? formData?.tc_acceptance_signature : ''}
                                    onChange={handleInputFieldsData}
                                    required=""
                                    type="text"
                                    onKeyPress={(e) => { allowAlphaNumericOnly(e, true) }}
                                    autoComplete="off"
                                    onPaste={(e) => {
                                        e.preventDefault()
                                        // Get copied data
                                        let pasted = (e.clipboardData || window.clipboardData).getData('text')
                                        // Convert to alphanumeric, allow spaces
                                        pasted = pasted.replace(/[^a-zA-Z0-9 ]/g, '')
                                        // Collapse multiple spaces to one
                                        pasted = pasted.replace(/\s+/g, ' ')
                                        // Trim left/right
                                        pasted = pasted.trim()
                                        // Set value for the input
                                        e.target.value = pasted

                                        // If using controlled input (likely): update formData
                                        if (typeof handleInputFieldsData === 'function') {
                                            // Mock an event with correct value
                                            handleInputFieldsData(e)
                                        }
                                    }}
                                />
                                {requiredTextInput(validator.current, 'tc_acceptance_signature', formData?.tc_acceptance_signature, 'Signature', 'required')}
                                {/* <span className="form-text text-danger h-40">{formError == 'pass' && !formData?.tc_acceptance_signature ? 'This field is required' : ''}</span> */}
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="mb-3 yankeeFix ">
                                <label className="form-label"> T&C Acceptance Date <span className='text-danger'> *</span></label>
                                <div className=' d-flex border align-items-center justify-content-between'>
                                    <DatePicker
                                        // disabled={true}
                                        disabled={tncDisabled}
                                        selected={formData?.tc_acceptance_date || new Date()}
                                        onChange={(date) => {
                                            formData['tc_acceptance_date'] = date
                                            setFormData({ ...formData })
                                        }}
                                        className="form-control border-0 flex-basis-1 "
                                        // timeIntervals={15}
                                        autoComplete="off"
                                        id="tc_acceptance_date"
                                        name="tc_acceptance_date"
                                        dateFormat="MMMM d, yyyy"
                                        minDate={new Date()}
                                        onKeyDown={(e) => { e.preventDefault() }}
                                    />
                                    {/* <i className=' fa fa-calendar-alt text-gray me-2' style={{ 'margin-left': '-100px', 'z-index': '2000', 'pointer-events': 'none' }} ></i> */}
                                </div>

                            </div>

                        </div>
                    </div>

                    : ''}
            </div> : null}
        </>
    )
}

TCAcceptanceSection.propTypes = {
    accessPermissions: PropTypes.array,
    formData: PropTypes.shape({
        userAcknowledge: PropTypes.bool,
        facility_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        tc_acceptance_signature: PropTypes.string,
        tc_acceptance_date: PropTypes.oneOfType([
            PropTypes.instanceOf(Date),
            PropTypes.string,
            PropTypes.number,
        ]),
    }),
    setFormData: PropTypes.func.isRequired,
    formError: PropTypes.string,
    partnerDetails: PropTypes.shape({
        term_condition_heading: PropTypes.string,
    }),
    validator: PropTypes.shape({
        current: PropTypes.object
    }),
    showTerm: PropTypes.bool.isRequired,
    setShowTerm: PropTypes.func.isRequired,
    handleInputFieldsData: PropTypes.func.isRequired,
    tncDisabled: PropTypes.bool.isRequired
}

export default TCAcceptanceSection
